import { combineReducers } from 'redux'
import { authReducer } from '../features/auth'
import { mfeReducer } from '../features/mfe'

export default combineReducers({
  auth: authReducer,
  mfe: mfeReducer,
})
